/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./accountSelect.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.accountSelect', deps)

  .directive('blAccountSelect', () => ({
    restrict: 'E',
    scope: {},
    bindToController: true,
    template: require('./accountSelect.html'),
    controller: require('./accountSelectCtrl.js'),
    controllerAs: 'vm',
  }));
